module.exports = __webpack_public_path__ + "assets/img/marriage-content-bg1.c6679d1c.png";